import { render } from "./SaleItem.vue?vue&type=template&id=afaaecec&scoped=true"
import script from "./SaleItem.vue?vue&type=script&lang=js"
export * from "./SaleItem.vue?vue&type=script&lang=js"

import "./SaleItem.vue?vue&type=style&index=0&id=afaaecec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afaaecec"]])

export default __exports__